import React from 'react';
import {withRouter} from "react-router-dom";
import {clearAllAlerts} from "../../store/calls/alertLoadingDispatch";

class HistoryListener extends React.Component {

    componentDidMount() {
        this.props.history.listen(location => {
            // ReactGA.pageview(location.pathname) -- insert pageview here
            clearAllAlerts();
        })
    }


    render() {
        return (
            <></>
        );
    }
}

export default withRouter(HistoryListener);
